import { render, staticRenderFns } from "./NlpWhyCheck.vue?vue&type=template&id=2c47bac4&scoped=true"
import script from "./NlpWhyCheck.vue?vue&type=script&lang=js"
export * from "./NlpWhyCheck.vue?vue&type=script&lang=js"
import style0 from "./NlpWhyCheck.vue?vue&type=style&index=0&id=2c47bac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c47bac4",
  null
  
)

export default component.exports